import { useState, useEffect } from "react";
import api, { API_BASE_URL } from "./api";

/**
 * Fetches the default company logo from the API.
 * Returns the full logo URL, or null while loading / if none exists.
 * Falls back silently so every letter template can keep its static
 * Logo.png import as a last resort.
 */
const useCompanyLogo = () => {
  const [logoUrl, setLogoUrl] = useState(null);

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      try {
        const companiesRes = await api.get("/companies");
        const companies = companiesRes.data || [];
        if (!companies.length) return;

        const companyId = companies[0].CompanyID ?? companies[0].id;
        if (!companyId) return;

        const logoRes = await api.get(`/company-logos/${companyId}`);
        const logo = logoRes.data;
        if (logo?.file_url && !cancelled) {
          setLogoUrl(`${API_BASE_URL}${logo.file_url}`);
        }
      } catch {
        // Silently fall back to the static logo import in the template
      }
    };

    load();
    return () => { cancelled = true; };
  }, []);

  return logoUrl;
};

export default useCompanyLogo;
